import * as Constants from './constants'

export const updateNhomKhachHangInfo = (formData, callback) => {
  return {
    type: Constants.KHACHHANG_NHOM_UPDATE_NHOM_KH,
    payload: formData,
    callback
  }
}

export const updateNhomKhachHangInfoSuccess = () => {
  return {
    type: Constants.KHACHHANG_NHOM_UPDATE_NHOM_KH_SUCCESS,
  }
}

export const updateNhomKhachHangInfoError = (error) => {
  return {
    type: Constants.KHACHHANG_NHOM_UPDATE_NHOM_KH_ERROR,
    payload: error
  }
}

export const khachHangNhomDetailRequest = (formData, callback) => {
  return {
    type: Constants.KHACHHANG_NHOM_DETAIL_REQUESTING,
    payload: formData,
    callback
  }
}

export const khachHangNhomDetailSuccess = () => {
  return {
    type: Constants.KHACHHANG_NHOM_DETAIL_SUCCESS,
  }
}

export const khachHangNhomDetailError = (error) => {
  return {
    type: Constants.KHACHHANG_NHOM_DETAIL_ERROR,
    error
  }
}

export const khachHangNhomUpdateRequest = (formData, callback) => {
  return {
    type: Constants.KHACHHANG_NHOM_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const khachHangNhomUpdateSuccess = (response) => {
  return {
    type: Constants.KHACHHANG_NHOM_UPDATE_SUCCESS,
    payload: response
  }
}

export const khachHangNhomUpdateError = (error) => {
  return {
    type: Constants.KHACHHANG_NHOM_UPDATE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/KhachHangNhom/actions.js